export default __webpack_public_path__ + "static/camarafintech-eef6bedbaee27d312c0d52a16efa9dd3.png";